export const todoSelector = (state) => state.todos.todos;
export const filterSelector = (state) => state.todos.filter;
